import { Controller } from "@hotwired/stimulus";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--address"
export default class extends Controller {
  static targets = ["prefecture", "city", "town", "addressKana"];
  static values = {
    delay: { type: Number, default: 500 },
  };

  connect() {
    this.timeoutId = null;
    TurboStreamHeaders(this);
  }

  disconnect() {
    this._clearExistingTimeout();
  }

  fill(e) {
    e.preventDefault();
    this._clearExistingTimeout();

    const value = e.currentTarget.value;
    this.timeoutId = setTimeout(() => {
      this._fetchData(value);
      this.timeoutId = null;
    }, this.delayValue);
  }

  _fetchData(value) {
    const params = new URLSearchParams();
    params.append("code", value);

    // response example
    // {prefecture_id: 13, city_id: 657, block_name: '南青山', address_kana: 'とうきょうとみなとくみなみあおやま'}
    fetch(`/zip_code.json?${params.toString()}`)
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then((data) => {
        if (Object.keys(data).length === 0) {
          return;
        }

        this._fillPrefecture(data.prefecture_id);
        this._fillCity(data.prefecture_id, data.city_id);
        this._fillTown(data.block_name);
        this._fillAddressKana(data.address_kana);
      })
      .catch((err) => {
        console.error("エラー:", err);
      });
  }

  _fillPrefecture(value) {
    this.prefectureTarget.value = value;
  }

  _fillCity(prefecture_id, city_id) {
    const params = {
      prefecture_id: prefecture_id,
      city_id: city_id,
      target_id: this.cityTarget.id,
    };
    const query = new URLSearchParams(params).toString();

    fetch(`/cities?${query}`, {
      method: "GET",
      headers: {
        ...this.turboStreamHeaders(),
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.text();
      })
      .then((html) => {
        // selectedはサーバ側で対応しているため、ここで設定はしない。
        Turbo.renderStreamMessage(html);
      })
      .catch((err) => {
        console.error("エラー:", err);
      });
  }

  _fillTown(value) {
    this.townTarget.value = value;
  }

  _fillAddressKana(value) {
    this.addressKanaTarget.value = value;
  }

  _clearExistingTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}
